import { computed } from 'mobx';

export default class ImageSourceModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = +item.id;
    this.name = item.name;
    this.protocol = item.protocol;
    this.address = item.address;
    this.user_name = item.user_name;
    this.password = item.password;
    this.interval = item.interval;
    this.timezone = item.timezone;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      protocol: this.protocol,
      address: this.address,
      user_name: this.user_name,
      password: this.password,
      interval: this.interval,
      timezone: this.timezone,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.protocol = json.protocol;
    this.address = json.address;
    this.user_name = json.user_name;
    this.password = json.password;
    this.interval = json.interval;
    this.timezone = json.timezone;
  }
}



// WEBPACK FOOTER //
// ./src/models/IDaq/ImageSourceModel.js